<template>
  <v-app>
    <AppHeader />
    <v-main>
      <SnackBar />
      <!-- If using vue-router -->
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from "@/modules/shared/views/AppHeader.vue";
import SnackBar from "@/modules/shared/components/SnackBarAlert.vue";
export default {
  components: {
    AppHeader,
    SnackBar
  },
  metaInfo: {
    title: "Sistema de Estancias Cortas",
    titleTemplate: "Sistema de Estancias Cortas",
  },
  name: "App",

  data: () => ({
    //
  }),
};
</script>
